import React, { useState, useEffect, createRef } from "react";

import { useScreenshot, createFileName } from "use-react-screenshot";

import "./TopBox.css";

function TopBox({ data }) {
  const [topBox, setTopBox] = useState([]);

  useEffect(() => {
    setTopBox(data);
  }, [data]);

  var allTable = "";
  for (var i = 0; i < topBox.length; i++) {
    var curItem = topBox[i];
    var keys = Object.keys(curItem);
    for (var j = 0; j < keys.length; j++) {
      var curKey = keys[j];
      var titleKey = curKey;
      if (titleKey == "Purchase_intent") {
        titleKey = "Purchase intent";
      }
      if (
        titleKey == "Addiction" ||
        titleKey == "Lasting" ||
        titleKey == "Strength"
      ) {
        allTable += `<tr class="tr tr__specific">
          <td class="topbox__title specific"> ${titleKey}</td> 
        `;
      } else {
        allTable += `<tr class="tr ">
          <td class="topbox__title"> ${titleKey}</td> 
        </tr>
        `;
      }

      var boxLines = curItem[curKey];

      if (
        titleKey == "Addiction" ||
        titleKey == "Lasting" ||
        titleKey == "Strength"
      ) {
        if (boxLines != null) {
          if (boxLines[0].Head != null) {
            allTable += `<td class="info-data"> ${boxLines[0].Head}%</td>`;
          } else {
            allTable += `<td class="info-data"> - </td>`;
          }

          if (boxLines[0].Heart != null) {
            allTable += `<td class="info-data"> ${boxLines[0].Heart}%</td>`;
          } else {
            allTable += `<td class="info-data"> - </td>`;
          }

          if (boxLines[0].In_use != null) {
            allTable += `<td class="info-data"> ${boxLines[0].In_use}%</td>`;
          } else {
            allTable += `<td class="info-data"> - </td>`;
          }

          allTable += `</tr>`;
        }
      } else {
        if (boxLines != null) {
          boxLines.map((line) => {
            allTable += `<tr>`;

            if (line.Title != null) {
              var curTitle = line.Title.replaceAll("_", " ").replaceAll(
                " perc",
                ""
              );
              allTable += `<td> ${curTitle}</td>`;
            } else {
              allTable += `<td> - </td>`;
            }

            if (line.Head != null) {
              allTable += `<td class="info-data"> ${line.Head}%</td>`;
            } else {
              allTable += `<td class="info-data"> - </td>`;
            }

            if (line.Heart != null) {
              allTable += `<td class="info-data"> ${line.Heart}%</td>`;
            } else {
              allTable += `<td class="info-data"> - </td>`;
            }

            if (line.In_use != null) {
              allTable += `<td class="info-data"> ${line.In_use}%</td>`;
            } else {
              allTable += `<td class="info-data"> - </td>`;
            }
            allTable += `</tr>`;
          });
        }
      }
      allTable += `</tr>`;
    }
  }

  const ref = createRef(null);
  const [image, takeScreenShot] = useScreenshot({
    type: "image/jpeg",
    quality: 1.0,
  });

  const download = (image, { name = "topbox", extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const downloadScreenshot = () => takeScreenShot(ref.current).then(download);

  return (
    <>
      <div className="topBox">
        <button onClick={downloadScreenshot} class="btn btn-left">
          Download
        </button>
        <table className="topBoxContent" ref={ref}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Head</th>
              <th>Heart</th>
              <th>In use</th>
            </tr>
          </thead>
          <tbody dangerouslySetInnerHTML={{ __html: allTable }}></tbody>
        </table>
      </div>
    </>
  );
}

export default TopBox;
